import { relations } from 'drizzle-orm';
import { pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core';
import { collarTypes } from './collar-types';
import { fabricTypes } from './fabric-types';
import { printTypes } from './print-types';
import { shirtTypes } from './shirt-types';
import { sleeveTypes } from './sleeve-types';

/**
 * Tabelas de junção N:N — só as duas FKs, sem colunas próprias. Definem quais combinações
 * de tipos são válidas no configurador de item de venda (equivalente ao que o app antigo
 * fazia com `@ManyToMany` do TypeORM, mas explícito aqui já que Drizzle não gera isso sozinho).
 */

export const shirtTypeSleeveTypes = pgTable(
  'shirt_type_sleeve_types',
  {
    shirtTypeId: uuid('shirt_type_id')
      .notNull()
      .references(() => shirtTypes.id, { onDelete: 'cascade' }),
    sleeveTypeId: uuid('sleeve_type_id')
      .notNull()
      .references(() => sleeveTypes.id, { onDelete: 'cascade' }),
  },
  (t) => [primaryKey({ columns: [t.shirtTypeId, t.sleeveTypeId] })],
);

export const shirtTypeCollarTypes = pgTable(
  'shirt_type_collar_types',
  {
    shirtTypeId: uuid('shirt_type_id')
      .notNull()
      .references(() => shirtTypes.id, { onDelete: 'cascade' }),
    collarTypeId: uuid('collar_type_id')
      .notNull()
      .references(() => collarTypes.id, { onDelete: 'cascade' }),
  },
  (t) => [primaryKey({ columns: [t.shirtTypeId, t.collarTypeId] })],
);

export const sleeveTypeFabricTypes = pgTable(
  'sleeve_type_fabric_types',
  {
    sleeveTypeId: uuid('sleeve_type_id')
      .notNull()
      .references(() => sleeveTypes.id, { onDelete: 'cascade' }),
    fabricTypeId: uuid('fabric_type_id')
      .notNull()
      .references(() => fabricTypes.id, { onDelete: 'cascade' }),
  },
  (t) => [primaryKey({ columns: [t.sleeveTypeId, t.fabricTypeId] })],
);

export const fabricTypePrintTypes = pgTable(
  'fabric_type_print_types',
  {
    fabricTypeId: uuid('fabric_type_id')
      .notNull()
      .references(() => fabricTypes.id, { onDelete: 'cascade' }),
    printTypeId: uuid('print_type_id')
      .notNull()
      .references(() => printTypes.id, { onDelete: 'cascade' }),
  },
  (t) => [primaryKey({ columns: [t.fabricTypeId, t.printTypeId] })],
);

export const shirtTypeSleeveTypesRelations = relations(
  shirtTypeSleeveTypes,
  ({ one }) => ({
    shirtType: one(shirtTypes, {
      fields: [shirtTypeSleeveTypes.shirtTypeId],
      references: [shirtTypes.id],
    }),
    sleeveType: one(sleeveTypes, {
      fields: [shirtTypeSleeveTypes.sleeveTypeId],
      references: [sleeveTypes.id],
    }),
  }),
);

export const shirtTypeCollarTypesRelations = relations(
  shirtTypeCollarTypes,
  ({ one }) => ({
    shirtType: one(shirtTypes, {
      fields: [shirtTypeCollarTypes.shirtTypeId],
      references: [shirtTypes.id],
    }),
    collarType: one(collarTypes, {
      fields: [shirtTypeCollarTypes.collarTypeId],
      references: [collarTypes.id],
    }),
  }),
);

export const sleeveTypeFabricTypesRelations = relations(
  sleeveTypeFabricTypes,
  ({ one }) => ({
    sleeveType: one(sleeveTypes, {
      fields: [sleeveTypeFabricTypes.sleeveTypeId],
      references: [sleeveTypes.id],
    }),
    fabricType: one(fabricTypes, {
      fields: [sleeveTypeFabricTypes.fabricTypeId],
      references: [fabricTypes.id],
    }),
  }),
);

export const fabricTypePrintTypesRelations = relations(
  fabricTypePrintTypes,
  ({ one }) => ({
    fabricType: one(fabricTypes, {
      fields: [fabricTypePrintTypes.fabricTypeId],
      references: [fabricTypes.id],
    }),
    printType: one(printTypes, {
      fields: [fabricTypePrintTypes.printTypeId],
      references: [printTypes.id],
    }),
  }),
);
